<template>
  <div name="health">
    <header class="inner-head border-transparent">
      <div class="flex justify-between">
        <h2 class="inner-head-title">Personal Challenge    <i class="icon fas fa-plus" title="Plus"></i></h2>
    
    
          <UpgradeOption v-if="shouldShowUpgrade" @pressed="showUpgrade()">
        </UpgradeOption>
        </div>
    </header>

    <div class="header-subnav-holder">

      <button
        v-for="path in tabsList"
        :key="path.id"
        type="button"
        class="header-subnav focus:outline-none"
        @click="showPath(path)"
        v-bind:class="[selectedPath.id === path.id ? 'selected' : '']"
      >
        {{ path.name }}
      </button>
    </div>
  
    <router-view />

        <UpgradeModal
      v-if="showUpgradeModal"
      @close="showUpgrade()"
      :area="'Health'"
    ></UpgradeModal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { upgradeMixin } from "@/mixins/upgradeMixin.js";

const UpgradeModal = () => import("@/components/upgrade/UpgradeModal.vue");
const UpgradeOption = () => import("@/components/upgrade/UpgradeOption.vue");

export default {
  name: "health",
    mixins: [upgradeMixin],
  props: [],
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
    }),
    showForSchool() {
      return this.currentUser.isSchool == true;
    },
    hasChallengeModule() {
      return this.currentAccess.challengeAccess;
    },
 tabsList() {
      return this.tabs
    }
  },
  data() {
    return {
      tabs: [],
      selectedPath: {},
    };
  },
  created() {
    this.selectedPath = this.PATH_DOCUMENTS
  },
  mounted() {
      this.tabs = [
      {id: 1, name: "Measures", path: "measures"},
       {id: 2, name: "Ventures", path: "taskgroups"},
    ]


    if (this.hasChallengeModule) {
      this.tabs.push(
        {id: 3, name: "Challenges", path: "challenges"}
      )
    }


    this.selectedPath = this.tabs[0]
  },
  methods: {
    showPath(object) { 
      if (this.selectedPath.id === object.id) { return }
      this.selectedPath = object;
      this.$router.push("/health/" + object.path);
    },
  },
  components: {
       UpgradeModal,
    UpgradeOption,
  },
};
</script>

<style scoped>
</style>